export default {
    getHours: { method: 'get', url: 'hours' },
    postHours: { method: 'post', url: 'hours' },
    putHours: { method: 'put', url: 'hours/{id}' },
    deleteHours: { method: 'delete', url: 'hours/{id}' },
    getIntegrationHours: { method: 'get', url: 'integration_hours' },
    postIntegrationHours: { method: 'post', url: 'integration_hours' },
    putIntegrationHours: { method: 'put', url: 'integration_hours/{id}' },
    deleteIntegrationHours: { method: 'delete', url: 'integration_hours/{id}' },
}
